import { Datum } from '../';


/**
 * A wrapper for an individual datum (usually part of a time series)
 */
export class FixedDatum extends Datum {
  /**
   * Initialize a Datum for a single fixed value
   * 
   * @param {Number} value Number (or number array) with measurement(s)
   */
  constructor(value) {
    if (typeof value !== 'number' && value !== null) {// || !Array.isArray(value))
      throw Error('Value is not a valid number');
    }

    let index = '';
    
    super(index, value);
  }
}